import {Component, Vue} from "vue-property-decorator";

interface Interface {
  parsePrice: Function;
}
@Component
export default class PriceHelper extends Vue {
  public parsePrice(price: number): string {
    if(!price){
      return '';
    }
    return price.toLocaleString(this.locale ?? 'nl-NL',{minimumFractionDigits: 2});
  }
  private get locale(): string {
    return this.$config.get('locale');
  }

}
